module.exports = {"name":"aboutThisBoard","meta":{"description":"Orients visitors of public boards by providing a description of what the board is about.","link":"https://trello.com/c/NFScY4Tm/298-about-this-board-experiment"},"audiences":["allMembers"],"defaults":{"enabled":false},"defaultWeight":1,"experimentAllocation":0,"experimentVersion":"v1","variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/aboutThisBoard.json
// module id = tHWo
// module chunks = 13